import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "status-container" }
const _hoisted_2 = { class: "application-actions" }
const _hoisted_3 = { class: "xpage-top-details-status" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { Permissions, PermissionLevels } from "@/models/permissions";
import PermissionsWrapper from "@/components/wrappers/PermissionsWrapper.vue";
import PermissionsButton from "@/components/wrappers/PermissionsButton.vue";
import ApplicationStatus from "@/components/v2/application/ApplicationStatus.vue";
import CancellationModal from "@/components/v2/application/refi/CancellationModal.vue";
import functions from "@/use/functions";
import axios from "axios";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ProductIds } from "@/types/types";
import { useRolesAccess } from '@/composables/usePermissionsAccess';
import { Roles } from '@/models/permissions';

interface ErrorResponseData {
  message?: string;
  errors?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationStatusContainer',
  setup(__props) {

const rootStore = useStore();

const applicationStore = useApplicationStore();

const router = useRouter();

const { summary } = storeToRefs(applicationStore);
const { inRole } = useRolesAccess();

const isRTC = computed<boolean>(() => summary.value.isRightToCancel);

const showCancelModal = ref<boolean>(false);

const oidcUser = computed(() => rootStore.getters["oidcStore/user"]);

const updateApplication = async () => {
  const referenceId = applicationStore.referenceId;
  await Promise.all([
    applicationStore.getApplication(referenceId),
    applicationStore.getApplicationSummary(referenceId),
    applicationStore.getApplicationComments(referenceId),
  ]);
};

const isAdmin = computed<boolean>(() => inRole(Roles.Admin));
const userCanMoveAppToLoanService = computed<boolean>(() => (applicationStore.viewModel.productTypeId === ProductIds.PEL && isAdmin.value) || applicationStore.viewModel.productTypeId !== ProductIds.PEL);

async function moveToLoanService(confirmation) {

  if (confirmation) {
    functions.openModal({
      title: "Confirm",
      description:
        "Are you sure you want to move this application to Loan Service?",
      buttons: [
        { title: "Cancel", onClick: () => functions.closeModal() },
        { title: "Submit", onClick: () => moveToLoanService(true) },
      ],
    });
  } else {
    functions.closeModal();

    try {
      await axios.post(
        `/api/applications/${applicationStore.applicationId}/migrate`,
        {
          AuthorizedByUserId: oidcUser.value?.sub,
          MigrateApplicationTargets: applicationStore.viewModel.id,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      functions.openModal({
        title: "Success",
        description: "Application has been successfully moved to Loan Service",
        buttons: [
          {
            title: "Close",
            onClick: () => {
              functions.closeModal();
              // refresh the page
              router.go(0);
            },
          },
        ],
      });
    } catch (error) {
      console.error("Error moving application to loan service", error);

      const modal = {
        title: "Error",
        description:
          "There was an issue moving this application to Loan Service",
        html: "",
      };

      if (axios.isAxiosError(error)) {
        const data = error.response?.data as ErrorResponseData;

        if (data) {
          if (data.message) {
            modal.description = data.message;
          }
          if (data.errors?.length) {
            modal.html = `<ul>${data.errors
              .map((e: string) => `<li>${e}</li>`)
              .join("")}</ul>`;
          }
        } else {
          modal.description = error.message;
        }
      } else if (error instanceof Error) {
        modal.description = error.message;
      } else {
        modal.description = "An unknown error occurred";
      }
      functions.openModal(modal);
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(PermissionsWrapper, {
          showDisabledIfNotVisible: true,
          permissionIds: [_unref(Permissions).ProgramConfiguration],
          permissionLevel: _unref(PermissionLevels).Update
        }, {
          default: _withCtx(() => [
            _createVNode(ApplicationStatus)
          ]),
          _: 1
        }, 8, ["permissionIds", "permissionLevel"]),
        (isRTC.value)
          ? (_openBlock(), _createBlock(PermissionsButton, {
              key: 0,
              permissionIds: [_unref(Permissions).RightToCancel],
              permissionLevel: _unref(PermissionLevels).Update,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showCancelModal.value = true)),
              class: "cancel-application-btn"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Cancel Application ", -1)
              ]))]),
              _: 1
            }, 8, ["permissionIds", "permissionLevel"]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_unref(applicationStore).viewModel.showMoveToLoanService)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (moveToLoanService(true))),
                class: "loan-service-btn",
                disabled: userCanMoveAppToLoanService.value === false
              }, [
                (_unref(applicationStore).viewModel.showMoveToLoanService)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Move To Loan Service »"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "Processing..."))
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ])), [
          [_directive_auto_animate, { ..._ctx.$animate, duration: 100 }]
        ])
      ])
    ]),
    (showCancelModal.value)
      ? (_openBlock(), _createBlock(CancellationModal, {
          key: 0,
          onUpdate: updateApplication,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showCancelModal.value = $event))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})